import React from "react";
import { useTranslation } from "next-i18next";
import Text from "@ds/components/Text";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import useStyles from "@containers/Insight/styles";
import color from "@definitions/mui/color";

const TabPartial: React.FC = () => {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation("common");

  const classes = useStyles({ isDesktop: true });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClickScroll = (type: string) => {
    if (typeof window !== "undefined") {
      const element = document.getElementById(type);

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  return (
    <Box
      bgcolor="white"
      sx={{ borderBottom: 1, borderColor: color.grey.light }}
      className={classes.tab}
    >
      <Tabs value={value} onChange={handleChange}>
        <Tab
          label={<Text variant="body2">{t("search.section.all")}</Text>}
          onClick={() => handleClickScroll("artikel")}
        />
        <Tab
          label={<Text variant="body2">{t("insight.article")}</Text>}
          onClick={() => handleClickScroll("artikel")}
        />
        <Tab
          label={<Text variant="body2">{t("insight.researchBusiness")}</Text>}
          onClick={() => handleClickScroll("riset")}
        />
        <Tab
          label={<Text variant="body2">{t("insight.successStory")}</Text>}
          onClick={() => handleClickScroll("cerita")}
        />
      </Tabs>
    </Box>
  );
};

export default TabPartial;
